import { useEffect } from "react";
import { SITE_URL } from "@/lib/seo";

const MERKEN = ["Kömmerling", "Schüco", "Aliplast", "Aluplast", "Deceuninck", "Veka", "Meranti", "Aluprof"];

/** Injecteert JSON-LD structured data (Organization + WebSite) in de <head>.
 *  `extra` = optionele array met extra schema-objecten (bv. Service/BreadcrumbList per regio). */
export function SeoJsonLd({ extra = [] }) {
  const extraKey = JSON.stringify(extra);
  useEffect(() => {
    const data = [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Work4you",
        url: SITE_URL,
        logo: `${SITE_URL}/og-image.jpg`,
        image: `${SITE_URL}/og-image.jpg`,
        email: "info@x-trading.be",
        description: "Marktplaats voor ramen- en deurenmontage: koppelt professionals, bedrijven en particulieren in België en Nederland.",
        areaServed: [
          { "@type": "Country", name: "België" },
          { "@type": "Country", name: "Nederland" },
        ],
        knowsAbout: [
          "PVC ramen", "Aluminium ramen", "Houten ramen", "Schuiframen",
          "Ramen monteren", "Raamkozijnen monteren", "Voordeuren", "Raam- en deurkozijnen",
          ...MERKEN,
        ],
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "Work4you",
        url: SITE_URL,
        inLanguage: "nl",
        potentialAction: {
          "@type": "SearchAction",
          target: `${SITE_URL}/opdrachten?type_werk={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
    ];
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-seo-jsonld", "true");
    el.text = JSON.stringify(extra.length ? [...data, ...extra] : data);
    document.head.appendChild(el);
    return () => { el.remove(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [extraKey]);
  return null;
}
